import _ from 'lodash';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import fetchChartsService from './fetchCharts';

export default ({
  user,
  domain,
  chart,
}) => new Promise((resolve) => {
  nsApi.post({
    object: 'chart',
    action: 'create',
  }, {
    domain,
    user,
    name: chart.name,
    type: chart.type,
    dashboard_id: chart.dashboard_id,
    properties: JSON.stringify(chart.properties),
    data_sources: JSON.stringify(chart.data_sources),
  }).then(() => {
    const chartToRead = {
      domain,
      user,
      placeholderId: chart.properties.placeholder_id,
      dashboard_id: chart.dashboard_id,
    };

    fetchChartsService(chartToRead).then((chartList) => {
      if (chartList[0]) {
        // eslint-disable-next-line no-undef
        const secondPost = _.cloneDeep(chartList[0]);
        nsApi.post({ // Second api request to create , but with the id this time.
          object: 'chart',
          action: 'create',
        }, {
          domain,
          user,
          id: secondPost.id,
          name: secondPost.name,
          type: secondPost.type,
          dashboard_id: secondPost.dashboard_id,
          properties: JSON.stringify(secondPost.properties),
          data_sources: JSON.stringify(secondPost.data_sources),
        });
      }
      resolve(chartList[0].id);
    }).catch((err) => {
      console.error(err);
      resolve(false);
    });
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
